import { RQAPICallWithData } from 'store/APIClient';
import { UserT } from 'business/definitions';
import { useQuery } from '@tanstack/react-query';

export type CsvOwnerT = Pick<UserT, 'id' | 'email'>;

const useGetCsvOwner = (tableName: string) => {
    return useQuery({
        queryKey: ['csv-owner', tableName],

        queryFn: async () => {
            const response = await RQAPICallWithData<CsvOwnerT>({
                endpoint: `schema/extension/table/${tableName}/owner`,
                method: 'GET',
            });
            return response.content.data;
        },
    });
};

export default useGetCsvOwner;
